import React, { useContext } from 'react'
import CheckBox from '../../common/CheckBox'
import { ConnectorViewMappingContext } from './context/context'

const SvgViewerToolbar = (props) => {
  const [state, dispatch] = useContext(ConnectorViewMappingContext)

  const toggleCheckBox = (key) => {
    dispatch({ type: key, data: !state[`${key}`] })
  }

  return (
    <div className="text-white bg-tracer-chrome-blue text-xl p-5">
      <div className="flex">
        <b className="flex-initial">Layers:</b>
        <span className="flex w-1/4 items-center">
          <div className="px-3">
            <CheckBox
              name="display_groups"
              value={state.displayGroups}
              checked={state.displayGroups}
              onChange={() => toggleCheckBox('displayGroups')}
            />
          </div>
          <span>SVG Groups</span>
        </span>
        <span className="flex w-1/4 items-center">
          <div className="px-3">
            <CheckBox
              name="display_source"
              value={state.displaySource}
              checked={state.displaySource}
              onChange={() => toggleCheckBox('displaySource')}
            />
          </div>
          <span>SVG Source</span>
        </span>
        <span className=" flex w-1/4 items-center">
          <div className="px-3">
            <CheckBox
              name="display_mappings"
              value={state.displayMappings}
              checked={state.displayMappings}
              onChange={() => toggleCheckBox('displayMappings')}
            />
          </div>
          <span>Mappings</span>
        </span>
        <span className=" flex w-1/4 items-center">
          <div className="px-3">
            <CheckBox
              name="display_png"
              value={state.displayPng}
              checked={state.displayPng}
              onChange={() => toggleCheckBox('displayPng')}
            />
          </div>
          <span>PNG</span>
        </span>
      </div>
    </div>
  )
}

export default SvgViewerToolbar
